import CONFIG from '../../Config';

import { AdminRoutes } from '../../Components/AdminRoutes';
import { AnonymousRoutes } from '../../Components/AnonymousRoutes';
import { AuthenticationRoutes } from '../../Components/AuthenticationRoutes';
import { ProtectedRoutes } from '../../Components/ProtectedRoutes';
import { Contracts } from '../../Scenes/Contracts';
import { Dashboard } from '../../Scenes/Dashboard';
import { EditContract } from '../../Scenes/EditContract';
import { EditParty } from '../../Scenes/EditParty';
import { EditProduct } from '../../Scenes/EditProduct';
import { EditQuotationSR } from '../../Scenes/EditQuotation';
import { EditSalesRoute } from '../../Scenes/EditSalesRoute';
import { Login } from '../../Scenes/Login';
import { ForgetPassword } from '../../Scenes/ForgetPassword';
import { ChangePassword } from '../../Scenes/ChangePassword';
// import { NewQuotationSR } from '../../Scenes/NewQuotation';
import { NewSurveySR } from '../../Scenes/NewSurvey';
import { NewSalesRoute } from '../../Scenes/NewSalesRoute';
import { Party } from '../../Scenes/Party';
import { Products } from '../../Scenes/Products';
// import { QuotationsSR } from '../../Scenes/Quotations';
import { SalesRoutes } from '../../Scenes/SalesRoutes';
import { Settings } from '../../Scenes/Settings';
import { Signature } from '../../Scenes/Signature';
import { Stats } from '../../Scenes/Stats';
import { EmprunteurPlus } from '../../Scenes/customer/EmprunteurPlus';

const i18n = {
  lang: 'fr',
  dateFormat: 'D MMM YYYY',
  compactDateFormat: 'D MMM YYYY',
  hourFormat: 'HH:mm:ss',
  fullDateFormat: 'D MMM YYYY / HH:mm',
  thousandSeparator: ' ',
  decimalSeparator: ',',
};

const navItems = [
  // {
  //   exact: false,
  //   label: 'Quotations',
  //   to: `/quotations`,
  //   icon: 'fa-quotations',
  // },
  {
    exact: false,
    label: 'Contracts',
    to: `/contracts`,
    icon: 'fa-contract',
  },
  {
    exact: false,
    label: 'Third parties',
    to: `/party`,
    icon: 'fa-user',
  },
  {
    exact: false,
    label: 'Products',
    to: `/products`,
    icon: 'fa-book',
  },
  {
    exact: false,
    label: 'SalesRoutes',
    to: `/salesroutes`,
    icon: 'fa-funnel-dollar',
  },
  {
    exact: false,
    label: 'Statistics',
    to: `/stats`,
    icon: 'fa-chart-bar',
    onlyAdmin: true,
  },
];

const routes = [
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/',
    redirectTo: '/login',
    component: Dashboard,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/party',
    redirectTo: '/login',
    component: Party,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/party/:id',
    redirectTo: '/login',
    component: EditParty,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/contracts',
    redirectTo: '/login',
    component: Contracts,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/contracts/:contractNumber',
    redirectTo: '/login',
    component: EditContract,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/settings',
    redirectTo: '/login',
    component: Settings,
  },
  // {
  //   route: ProtectedRoutes,
  //   exact: true,
  //   path: '/quotations',
  //   redirectTo: '/login',
  //   component: QuotationsSR,
  // },
  // {
  //   route: ProtectedRoutes,
  //   exact: true,
  //   path: '/quotations/new',
  //   redirectTo: '/login',
  //   component: NewQuotationSR,
  // },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/surveys/new',
    redirectTo: '/login',
    component: NewSurveySR,
  },
  // {
  //   route: ProtectedRoutes,
  //   exact: true,
  //   path: '/quotations/filter/:subscope?',
  //   redirectTo: '/login',
  //   component: QuotationsSR,
  // },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/quotations/:id',
    redirectTo: '/login',
    component: EditQuotationSR,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/products',
    redirectTo: '/login',
    component: Products,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/products/:id',
    redirectTo: '/login',
    component: EditProduct,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/salesroutes/new',
    redirectTo: '/login',
    component: NewSalesRoute,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/salesroutes/:id',
    redirectTo: '/login',
    component: EditSalesRoute,
  },
  {
    route: ProtectedRoutes,
    exact: true,
    path: '/salesroutes',
    redirectTo: '/login',
    component: SalesRoutes,
  },
  {
    route: AuthenticationRoutes,
    exact: true,
    path: '/login',
    redirectTo: '/',
    component: Login,
  },
  {
    route: AnonymousRoutes,
    exact: true,
    path: '/password',
    redirectTo: '/',
    component: ForgetPassword,
  },
  {
    route: AnonymousRoutes,
    exact: true,
    path: '/password/change/:token',
    redirectTo: '/',
    component: ChangePassword,
  },
  {
    route: AnonymousRoutes,
    exact: true,
    path: '/signature/:status',
    redirectTo: '/',
    component: Signature,
  },
  {
    route: AdminRoutes,
    exact: true,
    path: '/stats',
    redirectTo: '/',
    component: Stats,
  },
];

export const system = {
  i18n,
  dateFormat: 'YYYY-MM-DD',
  redirectTo: '/',
  menuDrawerSettings: {
    visible: CONFIG.menuDrawerSettings.visible,
  },
  navItems,
  routes,
};
